import { CREATE_SURGE_TEMPLATE, CREATE_SURGE_TEMPLATE_SUCCESS, CREATE_SURGE_TEMPLATE_ERROR, CREATE_SURGE_TEMPLATE_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateSurgeTemplate = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SURGE_TEMPLATE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_SURGE_TEMPLATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_SURGE_TEMPLATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_SURGE_TEMPLATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateSurgeTemplate;
